import HTTP from "../../http";

const PAYMENT_ENDPOINT = "/payments";
const STRIPE_CONFIRM_ENDPOINT = "/user/stripeConnectConfirm";

export async function confirmStripeConnect() {
  return await HTTP.get(PAYMENT_ENDPOINT + STRIPE_CONFIRM_ENDPOINT, {
    headers: { "Content-Type": "application/json" }
  });
}
